import { CartItem } from './cart';

// Define the Data Layer Events enum
// Events must be defined inside omnichannel-datalayer repo under Events folder
export enum DataLayerEventName {
  PRODUCT_ADDED = 'Product Added',
  CART_VIEWED = 'Cart Viewed',
  CHECKOUT_STARTED = 'Checkout Started',
  CHECKOUT_STEP_VIEWED = 'Checkout Step Viewed',
  CHECKOUT_STEP_COMPLETED = 'Checkout Step Completed',
  PRICE_UPDATED = 'Price Updated',
  QUOTE_REQUESTED = 'Quote Requested',
  SIGN_UP = 'Sign Up',
  SIGN_IN = 'Sign In',
  MARKETINT_EMAIL_OPT_IN = 'Marketing Email Opt-In',
}

export type DataLayerEventType =
  | { type: DataLayerEventName.PRODUCT_ADDED; payload: { cartItem: CartItem } }
  | { type: DataLayerEventName.QUOTE_REQUESTED; payload: { quote_id: string } }
  | { type: DataLayerEventName.CART_VIEWED }
  | { type: DataLayerEventName.CHECKOUT_STARTED }
  | { type: DataLayerEventName.CHECKOUT_STEP_VIEWED }
  | { type: DataLayerEventName.CHECKOUT_STEP_COMPLETED }
  | { type: DataLayerEventName.PRICE_UPDATED; payload: { total: number | undefined } }
  | {
      type: DataLayerEventName.SIGN_UP;
      payload: {
        company_id: number;
        user_id: number;
        first_name: string;
        last_name: string;
        company_name: string | undefined;
        email: string | undefined;
      };
    }
  | { type: DataLayerEventName.SIGN_IN }
  | {
      type: DataLayerEventName.MARKETINT_EMAIL_OPT_IN;
      payload?: { company_id?: number; user_id?: number; marketing_email_opt_in?: boolean };
    };
